export default "__VITE_ASSET__6548ca44__"